import { render, staticRenderFns } from "./SignupButton.vue?vue&type=template&id=3588b226&scoped=true&"
import script from "./SignupButton.vue?vue&type=script&lang=js&"
export * from "./SignupButton.vue?vue&type=script&lang=js&"
import style0 from "./SignupButton.vue?vue&type=style&index=0&id=3588b226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588b226",
  null
  
)

export default component.exports